import React from 'react';

import styles from './ask_footer.module.css';

const AskFooter = () => {
  return (
    <div className={styles.container}>
      <img
        className={styles.bg}
        src={process.env.PUBLIC_URL + '/imgs/etc/상담하기_bg.png'}
        alt=''
      />

      <div className={styles.contents}>
        <h2 className={styles.title}>
          어떤 문제로 고민이신가요?
          <br />
          우노스가 해결해 드릴게요.
        </h2>

        <div className={styles.btnBox}>
          {/* typeform */}
          {/* <div className={styles.btn} onClick={() => onTypeformClick(pathname)}>
            <TypeSlide>
              <div className={styles.onlineBtn}>
                <img
                  className={styles.icon}
                  src={process.env.PUBLIC_URL + '/imgs/etc/ask_online.png'}
                  alt='온라인'
                />
                <div className={styles.textBox}>
                  <span className={styles.askTitle}>온라인 상담 신청</span>
                  <span className={styles.desc}>
                    상담 예약 바로가기
                    <img
                      src={process.env.PUBLIC_URL + '/imgs/etc/arrow_black.png'}
                      alt=''
                    />
                  </span>
                </div>
              </div>
            </TypeSlide>
          </div> */}

          {/* kakaotalk */}
          <a
            className={styles.btn}
            href='https://www.beaverstorelab.com/contact?utm_source=unospay&utm_medium=internal&utm_campaign=contact'
          >
            <img
              className={styles.icon}
              src={process.env.PUBLIC_URL + '/imgs/etc/ask_online.png'}
              alt='카카오톡'
            />
            <div className={styles.textBox}>
              <span className={styles.askTitle}>상담신청</span>
              <span className={styles.desc}>
                요청하기
                <img
                  src={process.env.PUBLIC_URL + '/imgs/etc/arrow_black.png'}
                  alt=''
                />
              </span>
            </div>
          </a>

          {/* phone */}
          <div className={`${styles.btn} ${styles.phoneBtn}`}>
            <img
              className={styles.icon}
              src={process.env.PUBLIC_URL + '/imgs/etc/ask_phone.png'}
              alt='전화'
            />
            <div className={styles.textBox}>
              <span className={styles.askTitle}>1800-4520</span>
              <span className={styles.desc}>전화 상담하기</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AskFooter;
